<main>
  <div class="container-fluid">
    <div class="row justify-content-center mt-5">
      <div class="col-xxl-4 col-lg-5">
        <div class="card">

          <!-- Logo -->
          <div class="card-header pt-4 pb-4 text-center bg-dark">
            <a href="index.html">
              <span><img src="assets/images/logo.png" alt="" height="90"></span>
            </a>
          </div>

          <div class="card-body p-4">

            <div class="text-center w-100 m-auto">
              <h4 class="text-dark-50 text-center pb-0 fw-bold">Login</h4>
              <p class="text-muted mb-4">Inserisci username e password per effettuare l'accesso.</p>
            </div>

            <form id="formLogin" method="POST">

              <div class="mb-3">
                <label for="username" class="form-label">Username * </label>
                <input class="form-control" type="text" id="username" required="required" placeholder="Username">
              </div>

              <div class="mb-3">
                <label for="password" class="form-label">Password *</label>
                <div class="input-group input-group-merge">
                  <input type="password" id="password" class="form-control" required="required" placeholder="Password">
                  <div class="input-group-text" data-password="false" (click)="displayPassword($event)">
                    <span class="password-eye"></span>
                  </div>
                </div>
              </div>

              <div class="mb-3 mb-3">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="checkbox-signin" checked="">
                  <label class="form-check-label" for="checkbox-signin">Ricordami</label>
                </div>
              </div>

              <div class="mb-3 mb-0 text-center">
                <button class="btn btn-primary w-100" type="submit" (click)="onLogin($event)"> Login </button>
              </div>

              <div id="errorPermission" class="alert alert-danger mt-3" style="display:none">
                <strong><i class="fa fa-close"></i> Errori permessi</strong> {{messageError}}.
              </div>

              <div id="feedbackAlert" class="alert alert-danger mt-3" style="display:none">
                <strong><i class="fa fa-close"></i> Credenziali errate</strong> username o password non validi.
              </div>

              <div id="feedbackLoading" class="alert alert-info mt-3" style="display:none">
                <strong><i class="fa fa-spinner fa-spin"></i> Loading...</strong>
              </div>
            </form>
          </div> <!-- end card-body -->
        </div>

      </div>
    </div>
  </div>

</main>
